<template>
    <div class="certificate">
        <!-- add -->
        <div class="certificate-apply">
            <div class="certificate-apply__header">
                {{ messages.title }}
                <span class="certificate-apply__plus">
                <svg v-if="!isOpen" class="certificate-apply__icon"><use xlink:href="#svg-plus"></use></svg>
                <DefLink @click="handlerToggle">
                    {{ getControlMessage }}
                </DefLink>
            </span>
            </div>
            <SlideUpDown v-model="isOpen">
                <CertificateMain
                    @close="isOpen = false"
                    @setError="error = $event"
                    ref="inputBlock"
                />
            </SlideUpDown>
        </div>
        <!-- Error -->
        <CertificateError
            v-if="error"
            :result="error"
            @removeError="error = null"
        />
        <!-- Certificates -->
        <div
            v-if="certificates"
            class="certificate-items"
        >
            <CertificateCard
                v-for="(discount, certificate) in certificates"
                :result="{ certificate, discount }"
            />
        </div>
        <DefMessageSuccess v-if="certificates">
            <span>
                {{ messages.exist }}
            </span>
        </DefMessageSuccess>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import DefLink from "../../def/DefLink/DefLink";
import CertificateMain from "./CertificateMain";
import CertificateError from "./CertificateError";
import CertificateCard from "./CertificateCard";
import DefMessageSuccess from "../../def/DefMessages/DefMessageSuccess";

export default {
    name: 'Certificate',
    components: {
        DefLink,
        CertificateMain,
        CertificateError,
        CertificateCard,
        DefMessageSuccess,
    },
    data() {
        return {
            isOpen: false,
            error: null
        }
    },
    computed: {
        ...mapState({
            messages: ({ basket }) => basket.data?.messages?.certificates,
            certificates: ({ basket }) => basket.data?.price?.certificates,
        }),
        getControlMessage() {
            const { add, cancel } = this.messages;

            return this.isOpen ? cancel : add;
        },
    },
    methods: {
        handlerToggle() {
            this.isOpen = !this.isOpen;
            const inputBlock = this.$refs.inputBlock;
            if (inputBlock) {
                inputBlock.certificate = '';
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.certificate{

}
.certificate-items{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
}
.certificate-apply{
    background: #F6F6F6;
    border: 1px solid var(--border-grey);
    margin-top: 20px;
    &__header{
        display: flex;
        justify-content: space-between;
        padding: 20px 16px;
        font-weight: 500;
        @include point-md{
            padding: 20px 24px;
        }
    }
    &__plus{
        display: flex;
        align-items: center;
        font-size: rem(14);
    }
    &__icon{
        width: 16px;
        height: 16px;
        margin-right: 8px;
    }
}
.certificate-status{

}
</style>